module.exports = __webpack_public_path__ + "img/bg-empty.bab0cea9.svg";